import Deletebutton from './delete_button'

export default Deletebutton
